<template>
    <div>
        <!-- 应用商城 -->
        <el-dialog v-dialog-drag title="应用商城" :visible.sync="mallOpenDialogVisible"  class="eldialog eldialogmall" width="900px" :modal="true" @close="dialogClose" custom-class="full_dialog">
            <div class="mallBox">
                <div class="mallTab">
                    <img class="mallTabImg" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/pc/%E7%BB%84%201604.png">
                </div>
                <div class="mallBot">
                    <div class="BotBox" @click="toFinance">
                        <img class="BotImg" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/pc/%E8%92%99%E7%89%88%E7%BB%84%2046%402x.png">
                        <div class="Botspana"><span>融资管理系统</span></div>
                        <div><span class="Botspanb">融资管理</span></div>
                        <div class="Botspanc">融资管理系统是为了解决ERP用户在对外融资</div>
                        <div><span class="Botspanb">融资采购</span></div>
                        <div class="Botspanc">做融资采购时，付款方选择开展金融</div>
                        <div class="hideContent">
                            <div class="moreContent">
                                <img src="/icon/mallDetail.png" alt="">
                                <div>查看详情</div>
                            </div>
                        </div>
                    </div>
                    <div class="BotBox" @click="toMachining">
                        <img class="BotImg" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/pc/%E8%92%99%E7%89%88%E7%BB%84%2047%402x.png">
                        <div class="Botspana"><span>原木加工系统</span></div>
                        <div><span class="Botspanb">原木加工流程</span></div>
                        <div class="Botspanc">领料生产、湿板烘干、干板检尺入库、成品销售</div>
                        <div><span class="Botspanb">成品入库</span></div>
                        <div class="Botspanc">烘干后直接入口销售，所有加工费用平摊到</div>
                        <div class="hideContent">
                            <div class="moreContent">
                                <img src="/icon/mallDetail.png" alt="">
                                <div>查看详情</div>
                            </div>
                        </div>
                    </div>
                    <div class="BotBox" @click="toYunlian">
                        <img class="BotImg" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/pc/%E8%92%99%E7%89%88%E7%BB%84%2048%402x.png">
                        <div class="Botspana"><span>内部云链系统</span></div>
                        <div><span class="Botspanb">信息分享</span></div>
                        <div class="Botspanc">内部云链系统只是针对硬木行业内部贸易商</div>
                        <div><span class="Botspanb">共享理念</span></div>
                        <div class="Botspanc">借助他人渠道销售自己难销的货物</div>
                        <div class="hideContent">
                            <div class="moreContent">
                                <img src="/icon/mallDetail.png" alt="">
                                <div>查看详情</div>
                            </div>
                        </div>
                    </div>
                    <div class="BotBox" @click="toYunpu">
                        <img class="BotImg" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/pc/%E8%92%99%E7%89%88%E7%BB%84%2049%402x.png">
                        <div class="Botspana"><span>谱木云铺系统</span></div>
                        <div><span class="Botspanb">云铺系统</span></div>
                        <div class="Botspanc">自定义云铺，为ERP客户打造线上专属店铺</div>
                        <div><span class="Botspanb">同步货物</span></div>
                        <div class="Botspanc">通过ERP直接一键同步到云铺，帮助商家快速通过微信小程序向同行分享资源</div>
                        <div class="hideContent">
                            <div class="moreContent">
                                <img src="/icon/mallDetail.png" alt="">
                                <div>查看详情</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 金融 -->
        <!-- top="0vh"  -->
        <el-dialog  title="融资管理系统" :visible.sync="financeDialogVisible"  class="eldialogmall"  width="800px" :modal="true" @close="financeClose" custom-class="full_dialog">
            <div class="financeBox">
                <img class="financeImg" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/pc/%E8%9E%8D%E8%B5%84%E7%AE%A1%E7%90%86%402x.png" alt="">
                <div class="financeBot">
                    SAAS增值服务，详情咨询电话:13636535807
                    <!-- <span>电话:13636535807</span> -->
                </div>
            </div>
        </el-dialog>
        <!-- 金融 -->
        <el-dialog title="原木加工系统" :visible.sync="machiningDialogVisible"  class="eldialogmall" width="800px" :modal="true" @close="machinClose" custom-class="full_dialog">
            <div class="financeBox">
                <img class="financeImg" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/pc/%E5%8A%A0%E5%B7%A5%E7%B3%BB%E7%BB%9F%402x.png" alt="">
                <div class="financeBot">
                     SAAS增值服务，详情咨询电话:13636535807
                    <!-- SAAS增值服务，详情咨询
                    <span>电话:13636535807</span> -->
                </div>
            </div>
        </el-dialog>
        <!-- 云链 -->
        <el-dialog title="内部云链系统" :visible.sync="yunlianDialogVisible"  class="eldialogmall" width="800px" :modal="true" @close="yunlianClose" custom-class="full_dialog">
            <div class="financeBox">
                <img class="financeImg" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/pc/%E5%86%85%E9%83%A8%E4%BA%91%E9%93%BE%E7%B3%BB%E7%BB%9F%402x.png" alt="">
                <div class="financeBot">
                     SAAS增值服务，详情咨询电话:13636535807
                </div>
            </div>
        </el-dialog>
        <!-- 云铺 -->
        <el-dialog title="谱木云铺系统(外部)" :visible.sync="yunpuDialogVisible"  class="eldialogmall" width="800px" :modal="true" @close="yunpuClose" custom-class="full_dialog">
            <div class="financeBox">
                <img class="financeImg" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/pc/%E4%BA%91%E9%93%BA%E7%B3%BB%E7%BB%9F%402x.png" alt="">
                <div class="financeBot">
                     SAAS增值服务，详情咨询电话:13636535807
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        props:{
            DialogVisible: Boolean,
        },
        data(){
            return{
                mallOpenDialogVisible:this.DialogVisible,
                financeDialogVisible:false,
                machiningDialogVisible:false,
                yunlianDialogVisible:false,
                yunpuDialogVisible:false
            }
        },
        created() {
            
        },
        mounted() {
            
        },
        watch:{
            DialogVisible:function(val){
                this.mallOpenDialogVisible = val;
            }
        },
        methods:{
            dialogClose(){
                this.mallOpenDialogVisible = false;
                this.$emit('dialogClose',false);
            },
            // 金融
            toFinance(){
                // this.$root.$children[0].$children[0].addTab({
                //     name: '融资管理系统',
                //     label: '融资管理系统',
                //     content: 'financeDetail'
                // });
                // this.dialogClose();
                this.financeDialogVisible = true;
            },
            financeClose(){},
            //加工
            toMachining(){
                // this.$root.$children[0].$children[0].addTab({
                //     name: '原木加工系统',
                //     label: '原木加工系统',
                //     content: 'machiningDetail'
                // });
                // this.dialogClose();
                this.machiningDialogVisible = true;
            },
            machinClose(){

            },
            //云链
            toYunlian(){
                this.yunlianDialogVisible = true;
            },
            yunlianClose(){},
            //云铺
            toYunpu(){
                this.yunpuDialogVisible = true;
            },
            yunpuClose(){},
        }
    }
</script>
<style scoped lang="scss">
.mallTabImg{width: 100%;}
.mallBot{display: flex;padding: 20px;}
.BotBox{
    width: 25%;background-color: #333;color: linen;margin: 0 10px;text-align: center;border-radius: 5px;display: inline;
    position: relative;
    // &:hover{background-color: #444;}
    .BotImg{width: 130px;padding-top: 10px;}
    // .Botspan{color: linen;}
    .Botspana{font-size: 14px;padding-bottom: 10px;}
    .Botspanb{font-size: 12px;position: relative;}
    .Botspanb::after{position: absolute;bottom: -2px;left: calc(50% - 8px); content: '';border-radius: 21px;height: 2px;width: 15px;background-color: #fff;}
    .Botspanc{color: #777;padding:5px 10px;font-size: xx-small;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width: 190px;}
    .Botspanc :last-child{padding-bottom: 10px;}
    .hideContent{
        transition: 1s all;
        display: none;height: 100%;width: 100%;position: absolute;top: 0;left: 0;background: rgba(0,0,0, 0.6);cursor: pointer;border-radius: 4px;
        .moreContent{
            position: absolute;bottom: 15px;left: calc(50% - 53px);width: 106px;  padding: 3px 2px; display: flex;align-items: center;justify-content: center; border: 1px solid #fff;border-radius: 3px;
            font-size: 14px;
            img{width: 16px;margin-right: 2px;}
        }
    }
}
.BotBox:hover .hideContent{display: block;}
.financeBox{overflow-y: auto;padding-bottom: 40px;}
.financeImg{width: 780px;}
.financeBot{background-color: #333;line-height: 40px;text-align: center;color: #fff;position: absolute;bottom: 0;width: 100%;}
</style>